import * as React from 'react';
import { useToastWrapper } from './useToastWrapper';

var ToastWrapper = _ref => {
  var {
    children,
    dismiss,
    dismissable
  } = _ref;
  var {
    _onTouchEnd,
    _onTouchMove,
    _onTouchStart,
    style
  } = useToastWrapper({
    dismiss,
    dismissable
  });
  return /*#__PURE__*/React.createElement("div", {
    style: style,
    onTouchStart: _onTouchStart,
    onTouchMove: _onTouchMove,
    onTouchEnd: _onTouchEnd
  }, /*#__PURE__*/React.cloneElement(children, {}));
};

export { ToastWrapper };
//# sourceMappingURL=ToastWrapper.js.map